<template>
    <svg :width="width" :height="height" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.025 2H19.0036M7.70483 20.5766V26V20.5766ZM2.38774 24.5976V25.9641V24.5976ZM13.0219 15.9574V25.9741V15.9574ZM18.339 10.6143V25.9854V10.6143ZM23.6561 5.30324V25.9821V5.30324ZM1.05847 19.9452L19.0036 2L1.05847 19.9452Z"
            :stroke="color"
            stroke-width="2.81665"
            stroke-linecap="round"
            :fill="color"
            class="icon"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconObjectiveChart',
    props: {
        color: {
            type: String,
            default: '#6E6E6E',
        },
        width: {
            type: Number,
            default: 32,
        },
        height: {
            type: Number,
            default: 18,
        },
    },
}
</script>

<style lang="sass" scoped>
.icon
    transition: 0.5s ease all
</style>
